{ /*
  * CommonComponents.tsx
  *
  * Exports: BulletPoint
  *
  * Description: BulletPoint is the standard "<li>" component; it works inside "<ul>" and "<ol>" elements.
  */
}
import styled from 'styled-components';
const DocsPageBulletPoint = styled.li `
    margin-bottom: 10px;
    font-family: "AL-AvenirNext-Regular", sans-serif;
`;
export default DocsPageBulletPoint;
//# sourceMappingURL=DocsPageBulletPoint.js.map